import {Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild} from '@angular/core';
import {EndpointsService} from "../../services/endpoints.service";
import {HttpApiService} from "../../services/http-api.service";
import {AlertMessageComponent, AlertType} from "../alert-message/alert-message.component";
import {UserService} from "../../services/user.service";
import {AccordionConfig, ModalDirective} from "ngx-bootstrap";
export function getAccordionConfig(): AccordionConfig {
  return Object.assign(new AccordionConfig(), { closeOthers: true });
}

@Component({
  selector: 'app-pricing-plan',
  templateUrl: './pricing-plan.component.html',
  styleUrls: ['../../components/app-profile/app-profile.component.scss', './pricing-plan.component.scss'],
  providers: [{ provide: AccordionConfig, useFactory: getAccordionConfig }]
})

export class PricingPlanComponent implements OnInit, OnChanges {
  ngOnChanges(changes: any): void {
    console.log(changes);
  }
  @Input() isPricingDisplay = false;
  @Output() itemAdOnsAndFeatures;
  @Output() tierIndex = 0;
  @Input() item: any = {};
  @Input() profile: any = {};
  @Input() showEditOptions: boolean;
  @Input() reseller: any = {};
  @Output() selectPricingPlan: EventEmitter<any> = new EventEmitter();
  @Output() buyProduct: EventEmitter<any> = new EventEmitter();
  @Output() gotoRFQ: EventEmitter<any> = new EventEmitter();
  @Output() quantityUpdated: EventEmitter<any> = new EventEmitter();
  @Output() onEditPricingPlan: EventEmitter<any> = new EventEmitter();
  @Output() onDeletePricingPlan: EventEmitter<any> = new EventEmitter();
  @Output() onDuplicatePricingPlan: EventEmitter<any> = new EventEmitter();
  @ViewChild('specialOfferModal') public specialOfferModal: ModalDirective;
  @Input() specialOffers = '';
  constructor(private endpoints: EndpointsService,
              private userService: UserService,
              private api: HttpApiService) {
  }

  ngOnInit() {
    this.itemAdOnsAndFeatures = this.item && this.item.pricingTiers ? this.item.pricingTiers[0] : {};
  }

  selectPricingPlanEvent(item) {
    this.selectPricingPlan.emit(item);
  }

  buyProductEvent(item) {
    this.buyProduct.emit(item);
  }

  duplicatePricingPlan() {
    this.onDuplicatePricingPlan.emit(this.item);
  }

  gotoRFQEvent(item) {
    this.gotoRFQ.emit(item);
  }

  updateQuantity(value) {
    this.quantityUpdated.emit(value);
  }

  deletePricingPlan() {
    this.onDeletePricingPlan.emit(this.item);
  }

  editPricingPlan() {
    if (!this.item.billingCycle) {
      this.item.billingCycle = {};
    }
    this.onEditPricingPlan.emit(this.item);
  }

  isLoggedIn() {
    return this.userService.isLoggedIn();
  }
  isReseller() {
    return this.userService.isReseller();
  }

  isBuyer() {
    return this.userService.isBuyer();
  }

  isVendor() {
    return this.userService.isVendor();
  }

  isSuperAdmin() {
    return this.userService.isSuperAdmin();
  }

  changeAddOnAndFeature() {
    this.itemAdOnsAndFeatures = this.item.pricingTiers[this.tierIndex];
  }

  showSpecialOfferModal(specialOffers) {
    this.specialOffers = specialOffers;
    this.specialOfferModal.show();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/pricing-plan/pricing-plan.component.ts